(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["enigmae-general-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('enigmae-general')) {
  customElements.define('enigmae-general', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.form = this.querySelector('.egp-form');
      this.select = this.querySelector('select[name="id"]');
      this.image = this.querySelector('.egp-featured');
      this.status = this.querySelector('.egp-form-status');
      this.fields = [...this.querySelectorAll('[data-option]')];
      this.addButtons = [...this.querySelectorAll('button[type="submit"]')];
      const optionFields = this.querySelector('.egp-option-fields');
      if (optionFields) optionFields.hidden = false;
      this.querySelector('.egp-native-variant').hidden = true;
      this.current = this.variants.find(v => String(v.id) === this.select.value);
      this.fields.forEach(field => {
        const checked = field.querySelector('input:checked');
        if (checked) field.querySelector('[data-selection]').textContent = checked.dataset.label;
        field.addEventListener('change', () => this.updateVariant(true));
      });
      this.querySelectorAll('.egp-thumb').forEach(button => button.addEventListener('click', () => {
        this.showImage(button.dataset.image, button.dataset.alt);
        this.querySelectorAll('.egp-thumb').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      }));
      const url = new URL(window.location.href);
      if (url.searchParams.has('variant') && this.current?.image) this.showImage(this.current.image);
      const toggle = this.querySelector('.egp-review-toggle');
      if (toggle) {
        toggle.hidden = false;
        this.querySelectorAll('[data-extra-review]').forEach(el => el.hidden = true);
        toggle.addEventListener('click', () => {
          const expanded = toggle.getAttribute('aria-expanded') !== 'true';
          this.querySelectorAll('[data-extra-review]').forEach(el => el.hidden = !expanded);
          toggle.setAttribute('aria-expanded', String(expanded));
          toggle.textContent = expanded ? toggle.dataset.less : toggle.dataset.more;
        });
      }
      this.qty = this.querySelector('input[name="quantity"]');
      this.querySelectorAll('.egp-tier').forEach(btn => btn.addEventListener('click', () => {
        this.querySelectorAll('.egp-tier').forEach(other => other.classList.toggle('is-active', other === btn));
        if (this.qty) this.qty.value = btn.dataset.qty;
        this.paintBundle();
      }));
      this.form.addEventListener('submit', event => this.addToCart(event));
      const sticky = this.querySelector('.egp-sticky');
      sticky.querySelector('button').addEventListener('click', event => { event.preventDefault(); this.querySelector('.egp-add').click(); });
      this.observer = new IntersectionObserver(([entry]) => {
        sticky.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0;
      }, {threshold: 0});
      this.observer.observe(this.form);
    }
    disconnectedCallback() { this.observer?.disconnect(); }
    showImage(src, alt) {
      if (!src || !this.image) return;
      this.image.removeAttribute('srcset');
      this.image.src = src;
      if (alt) this.image.alt = alt;
    }
    updateVariant(changeUrl) {
      const options = this.fields.map(f => f.querySelector('input:checked')?.value);
      this.fields.forEach(f => { const input = f.querySelector('input:checked'); if (input) f.querySelector('[data-selection]').textContent = input.dataset.label; });
      this.current = this.variants.find(v => v.options.every((o, i) => o === options[i]));
      const available = Boolean(this.current?.available);
      this.addButtons.forEach(b => b.disabled = !available);
      this.querySelectorAll('[data-add-label]').forEach(el => el.textContent = this.current ? (available ? this.dataset.add : this.dataset.sold) : this.dataset.unavailable);
      this.querySelectorAll('[data-price]').forEach(el => el.textContent = this.current?.price || '—');
      const compare = this.querySelector('[data-compare]');
      compare.hidden = !this.current?.compare;
      compare.textContent = this.current?.compare || '';
      this.querySelector('[data-stock]').textContent = available ? this.dataset.stock : this.dataset.sold;
      this.status.textContent = '';
      this.select.value = this.current ? String(this.current.id) : '';
      if (this.current?.image) {
        this.showImage(this.current.image);
        this.querySelectorAll('.egp-thumb').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.image === this.current.image)));
      }
      if (changeUrl && this.current) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', this.current.id);
        window.history.replaceState({}, '', url);
      }
      this.paintBundle();
    }
    paintBundle() {
      if (!this.current) return;
      const set = (sel, value) => { const el = this.querySelector(sel); if (el && value) el.textContent = value; };
      set('[data-bundle-total="1"]', this.current.price);
      set('[data-bundle-total="2"]', this.current.b2);
      set('[data-bundle-total="3"]', this.current.b3);
      set('[data-bundle-each="2"]', this.current.e2);
      set('[data-bundle-each="3"]', this.current.e3);
      const qty = this.querySelector('.egp-tier.is-active')?.dataset.qty || '1';
      const shown = qty === '2' ? this.current.b2 : qty === '3' ? this.current.b3 : this.current.price;
      if (shown) this.querySelectorAll('.egp-add [data-price], .egp-sticky [data-price]').forEach(el => el.textContent = shown);
    }
    async addToCart(event) {
      event.preventDefault();
      if (this.busy || !this.current?.available || !this.form.reportValidity()) return;
      this.busy = true;
      this.addButtons.forEach(b => b.disabled = true);
      this.status.textContent = this.dataset.busy;
      const root = window.Shopify?.routes?.root || '/';
      const formData = new FormData(this.form);
      formData.set('id', String(this.current.id));
      try {
        const response = await fetch(root + 'cart/add.js', {method:'POST', body:formData, headers:{Accept:'application/json'}});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || this.dataset.error);
        this.status.textContent = this.dataset.done;
        window.location.assign(root + 'cart');
      } catch (error) {
        this.status.textContent = error.message || this.dataset.error;
        this.addButtons.forEach(b => b.disabled = !this.current?.available);
        this.busy = false;
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enigmae-halloween-universal"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('halloween-product')){customElements.define('halloween-product',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.data=JSON.parse(this.querySelector('[data-hwu-data]').textContent);this.select=this.querySelector('[data-hwu-variant]');this.options=[...this.querySelectorAll('[data-hwu-option]')];this.querySelector('[data-hwu-options]').hidden=false;this.querySelector('[data-hwu-variant-list]').hidden=true;this.options.forEach(el=>el.addEventListener('change',()=>this.update()));this.addEventListener('click',event=>{const b=event.target.closest('[data-hwu-choice]');if(!b||!this.contains(b))return;this.options=[...this.querySelectorAll('[data-hwu-option]')];this.select=this.querySelector('[data-hwu-variant]');this.options[Number(b.dataset.hwuOptionIndex)].value=b.dataset.hwuChoice;this.update()},true);this.querySelectorAll('[data-hwu-thumb]').forEach(el=>el.addEventListener('click',()=>this.media(el.dataset.hwuThumb)));this.querySelectorAll('[data-hwu-direction]').forEach(b=>b.addEventListener('click',()=>{const slides=[...this.querySelectorAll('[data-hwu-media]')];const i=slides.findIndex(s=>!s.hidden);this.media(slides[(i+Number(b.dataset.hwuDirection)+slides.length)%slides.length].dataset.hwuMedia)}));this.select.addEventListener('change',()=>{const v=this.data.variants.find(v=>String(v.id)===this.select.value);if(v){this.options.forEach((el,i)=>el.value=v.options[i]);this.paint(v)}});this.observer=new IntersectionObserver(entries=>{this.querySelector('[data-hwu-sticky]').hidden=entries[0].isIntersecting||entries[0].boundingClientRect.top>0},{threshold:0});this.observer.observe(this.querySelector('.hwu-form'));}
disconnectedCallback(){if(this.observer)this.observer.disconnect();this.ready=false;}
media(id){this.querySelectorAll('[data-hwu-media]').forEach(el=>{el.hidden=el.dataset.hwuMedia!==String(id);if(el.hidden)el.querySelectorAll('video').forEach(v=>v.pause())});this.querySelectorAll('[data-hwu-thumb]').forEach(el=>el.setAttribute('aria-pressed',String(el.dataset.hwuThumb===String(id))))}
update(){this.options=[...this.querySelectorAll('[data-hwu-option]')];this.select=this.querySelector('[data-hwu-variant]');const values=this.options.map(el=>el.value);const variant=this.data.variants.find(v=>v.options.every((v,i)=>v===values[i]));this.select.value=variant?String(variant.id):'';this.paint(variant);this.select.dispatchEvent(new Event('change',{bubbles:true}));if(variant){const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url)}}
paint(v){this.querySelectorAll('[data-hwu-choice]').forEach(b=>b.setAttribute('aria-pressed',String(this.options[Number(b.dataset.hwuOptionIndex)].value===b.dataset.hwuChoice)));const button=this.querySelector('[data-hwu-add]');button.disabled=!v||!v.available;button.querySelector('span').textContent=!v?this.data.labels.unavailable:v.available?this.data.labels.add:this.data.labels.sold;this.querySelector('[data-hwu-availability]').textContent=!v?this.data.labels.unavailable:v.available?this.data.labels.available:this.data.labels.sold;if(!v)return;this.querySelector('[data-hwu-price]').textContent=v.price;this.querySelector('[data-hwu-sticky-price]').textContent=v.price;const compare=this.querySelector('[data-hwu-compare]'),saving=this.querySelector('[data-hwu-saving]');compare.hidden=!v.onSale;saving.hidden=!v.onSale;compare.textContent=v.compare;saving.textContent=v.saving;if(v.mediaId)this.media(v.mediaId)}
})}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
